import { render, staticRenderFns } from "./HelpCenterModal.vue?vue&type=template&id=a58e67fc&scoped=true"
import script from "./HelpCenterModal.vue?vue&type=script&lang=js"
export * from "./HelpCenterModal.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterModal.vue?vue&type=style&index=0&id=a58e67fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58e67fc",
  null
  
)

export default component.exports